import { render } from "./SiteActivity.vue?vue&type=template&id=3af0820d&ts=true"
import script from "./SiteActivity.vue?vue&type=script&lang=ts"
export * from "./SiteActivity.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__